/* Balanze — custom-balanze.js */

(function () {
  'use strict';

  function init() {
    initFaq();
    initVariantPicker();
    initGallery();
    initNav();
    initSocialVideos();
    initIngTabs();
    initRvSlider();
    initDermModal();
    initBaSlider();
    initQuiz();
    initRecentSales();
    clearCartOnProductPage();
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll('.bz-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.bz-faq__item');
        var isOpen = item.classList.contains('bz-open');
        document.querySelectorAll('.bz-faq__item').forEach(function (el) {
          el.classList.remove('bz-open');
        });
        if (!isOpen) { item.classList.add('bz-open'); }
      });
    });
  }

  /* Variant picker — highlight selected + swap main image */
  function initVariantPicker() {
    document.querySelectorAll('.bz-variant-opt input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var picker = this.closest('.bz-variant-picker');
        if (!picker) return;
        picker.querySelectorAll('.bz-variant-opt').forEach(function (opt) {
          opt.classList.remove('bz-selected');
        });
        this.closest('.bz-variant-opt').classList.add('bz-selected');

        if (this.dataset.variantImage) {
          swapGalleryMain(this.dataset.variantImage, false);
        }
      });
    });
  }

  /* Gallery carousel — thumbnails, dots, scroll sync */
  function scrollGalleryToSlide(track, idx, smooth) {
    if (!track) return;
    track.scrollTo({ left: idx * track.offsetWidth, behavior: smooth ? 'smooth' : 'auto' });
    syncGalleryUI(idx);
  }

  function syncGalleryUI(idx) {
    document.querySelectorAll('.bz-gallery__dot').forEach(function (dot, i) {
      dot.classList.toggle('bz-active', i === idx);
    });
    document.querySelectorAll('.bz-gallery__thumb').forEach(function (thumb) {
      thumb.classList.toggle('bz-active', parseInt(thumb.dataset.slide || '0') === idx);
    });
  }

  function initGallery() {
    var track = document.querySelector('.bz-gallery__track');

    document.querySelectorAll('.bz-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(this.dataset.slide || '0');
        if (track) {
          scrollGalleryToSlide(track, idx, true);
        } else {
          var main = document.getElementById('bz-gallery-main');
          if (main) { main.src = this.dataset.src; main.srcset = ''; }
          syncGalleryUI(idx);
        }
      });
    });

    document.querySelectorAll('.bz-gallery__dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollGalleryToSlide(track, parseInt(this.dataset.index), true);
      });
    });

    if (track) {
      track.addEventListener('scroll', function () {
        var w = track.offsetWidth;
        if (!w) return;
        var idx = Math.round(track.scrollLeft / w);
        syncGalleryUI(idx);
      }, { passive: true });
    }
  }

  /* Nav — sticky scroll shadow + mobile hamburger */
  function initNav() {
    var nav = document.querySelector('.bz-nav');
    if (!nav) return;

    window.addEventListener('scroll', function () {
      nav.classList.toggle('bz-nav--scrolled', window.scrollY > 20);
    }, { passive: true });

    var burger = nav.querySelector('.bz-nav__burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('bz-nav--open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      var drawer = nav.querySelector('.bz-nav__drawer');
      if (drawer) drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    function closeDrawer() {
      nav.classList.remove('bz-nav--open');
      burger.setAttribute('aria-expanded', 'false');
      var drawer = nav.querySelector('.bz-nav__drawer');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    }

    nav.querySelectorAll('.bz-nav__drawer-link, .bz-nav__drawer .bz-btn').forEach(function (link) {
      link.addEventListener('click', closeDrawer);
    });

    var overlay = nav.querySelector('.bz-nav__overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    var closeBtn = nav.querySelector('.bz-nav__drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* Clear cart on product page so every visit starts fresh (handles Kaching Bundles + bfcache) */
  function clearCartOnProductPage() {
    if (!document.getElementById('bz-product-form')) return;
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    }).catch(function () {});
  }

  /* Restore cart on bfcache navigation */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) clearCartOnProductPage();
  });

  /* Social proof video carousel — autoplay on scroll into view */
  function initSocialVideos() {
    var vids = document.querySelectorAll('.bz-svideo__vid');
    if (!vids.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target.tagName !== 'VIDEO') return;
        if (entry.isIntersecting) {
          entry.target.play().catch(function () {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.4 });

    vids.forEach(function (vid) { observer.observe(vid); });
  }

  /* Ingredient zone tabs */
  function initIngTabs() {
    document.querySelectorAll('.ing-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabId = this.dataset.tab;
        var container = this.closest('.bz-ing-zones');
        if (!container) return;
        container.querySelectorAll('.ing-tab').forEach(function (t) { t.classList.remove('active'); });
        container.querySelectorAll('.ing-panel').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        var panel = container.querySelector('#ing-' + tabId);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* Review image slider */
  function initRvSlider() {
    document.querySelectorAll('.rv-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slider = document.getElementById(this.dataset.slider);
        if (!slider) return;
        var slide = slider.querySelector('.rv-slide');
        if (!slide) return;
        var dir = parseInt(this.dataset.dir, 10);
        slider.scrollBy({ left: dir * slide.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  /* Before / After image slider */
  function initBaSlider() {
    document.querySelectorAll('.bas-container').forEach(function (container) {
      var before = container.querySelector('.bas-before');
      var divider = container.querySelector('.bas-divider');
      if (!before || !divider) return;

      var dragging = false;

      function setPosition(clientX) {
        var rect = container.getBoundingClientRect();
        var pct = Math.max(2, Math.min(98, ((clientX - rect.left) / rect.width) * 100));
        before.style.clipPath = 'inset(0 ' + (100 - pct).toFixed(2) + '% 0 0)';
        divider.style.left = pct.toFixed(2) + '%';
      }

      divider.addEventListener('mousedown', function (e) {
        dragging = true;
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) { setPosition(e.clientX); }
      });
      document.addEventListener('mouseup', function () { dragging = false; });

      divider.addEventListener('touchstart', function (e) {
        dragging = true;
        e.stopPropagation();
      }, { passive: true });
      document.addEventListener('touchmove', function (e) {
        if (dragging && e.touches[0]) { setPosition(e.touches[0].clientX); }
      }, { passive: true });
      document.addEventListener('touchend', function () { dragging = false; }, { passive: true });
    });
  }

  /* Derm badge modal + modal FAQ */
  function initDermModal() {
    // Open modal
    document.querySelectorAll('[data-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dialog = document.getElementById(this.dataset.modal);
        if (dialog && dialog.showModal) dialog.showModal();
      });
    });

    // Close button
    document.querySelectorAll('[data-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dialog = this.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    // Close on backdrop click
    document.querySelectorAll('.derm-modal').forEach(function (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    });

    // Modal FAQ accordion
    document.querySelectorAll('.derm-mfaq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        this.closest('.derm-mfaq__item').classList.toggle('open');
      });
    });
  }

  /* Quiz — pending block state (survives shopify:section:load) */
  var _quizPendingBlock = null; // { sectionId, blockId }

  function _quizJumpToBlock(sectionEl, blockId) {
    /* DOM-based lookup: Liquid renders data-bid="{{ block.id }}" directly,
       so the string always matches e.detail.blockId without JSON parsing risk */
    var spans = sectionEl.querySelectorAll('.bz-quiz__bmap [data-bid]');
    for (var i = 0; i < spans.length; i++) {
      if (spans[i].dataset.bid === blockId) {
        if (spans[i].dataset.btype === 'q') {
          var idx = parseInt(spans[i].dataset.bidx, 10);
          if (sectionEl._quizGoTo) sectionEl._quizGoTo(idx);
          return true;
        }
        if (spans[i].dataset.btype === 'r') {
          if (sectionEl._quizShowResult) sectionEl._quizShowResult(spans[i].dataset.bkey);
          return true;
        }
      }
    }
    return false;
  }

  /* Quiz — schema-driven, results editable, theme-editor block jump */
  function initQuiz() {
    document.querySelectorAll('.bz-quiz').forEach(function (section) {
      if (section.dataset.designMode) return; /* design mode: Liquid renders all blocks statically */
      var slidesWrap   = section.querySelector('.bz-quiz__slides');
      var progressFill = section.querySelector('.bz-quiz__progress-fill');
      if (!slidesWrap) return;

      var sectionId = section.id.slice('bz-quiz-'.length);
      var dataEl = document.getElementById('bz-quiz-data-' + sectionId);
      if (!dataEl) return;

      var quizData;
      try { quizData = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var questions = (quizData && quizData.questions) || [];
      if (!questions.length) return;

      var ctaUrl    = section.dataset.ctaUrl    || '#';
      var ctaText   = section.dataset.ctaText   || 'Ver mi plan personalizado';
      var sheetsUrl = section.dataset.sheetsUrl || '';

      var answers = {};

      /* ── helpers ── */
      function escHtml(s) {
        return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
      }
      function escAttr(s) {
        return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;');
      }
      /* Renders user content allowing <strong> and <em> only — safe against XSS */
      function renderHtml(s) {
        return escHtml(s)
          .replace(/&lt;strong&gt;/gi, '<strong>').replace(/&lt;\/strong&gt;/gi, '</strong>')
          .replace(/&lt;em&gt;/gi, '<em>').replace(/&lt;\/em&gt;/gi, '</em>');
      }
      /* Protocol items: auto-bolds ingredient name (part before —) if not already bolded */
      function fmtProtocol(text) {
        var s = renderHtml(text);
        if (s.indexOf('<strong>') === -1) {
          s = s.replace(/^(.+?)(\s*[—–]\s*)(.+)$/, '<strong>$1</strong>$2$3');
        }
        return s;
      }

      /* ── progress ── */
      function setProgress(step, total) {
        if (progressFill) progressFill.style.width = ((step / total) * 100).toFixed(1) + '%';
      }

      /* ── scoring — most frequent result-mapped tag ── */
      function calcResult() {
        var allResults = (quizData && quizData.results) || {};
        var counts = {};
        Object.keys(answers).forEach(function (qid) {
          var vals = Array.isArray(answers[qid]) ? answers[qid] : [answers[qid]];
          vals.forEach(function (v) {
            if (v && allResults[v]) counts[v] = (counts[v] || 0) + 1;
          });
        });
        var best = null, bestCount = 0;
        Object.keys(counts).forEach(function (k) {
          if (counts[k] > bestCount) { best = k; bestCount = counts[k]; }
        });
        if (best) return best;
        /* fallback: block marked as default, or first result */
        var fallback = null;
        Object.keys(allResults).forEach(function (k) {
          if (allResults[k].isDefault && !fallback) fallback = k;
        });
        return fallback || Object.keys(allResults)[0] || '';
      }

      /* ── Google Sheets ── */
      function sendToSheets() {
        if (!sheetsUrl) return;
        var payload = {
          timestamp: new Date().toISOString(),
          page: window.location.href,
          result: calcResult(),
          answers: questions.map(function (q) {
            var ans = answers[q.id];
            /* Map stored val back to human-readable label for options questions */
            var display = ans;
            if (q.opts && q.opts.length) {
              var valToLabel = {};
              q.opts.forEach(function (o) { valToLabel[o.val] = o.label; });
              if (Array.isArray(ans)) {
                display = ans.map(function (v) { return valToLabel[v] || v; }).join(' | ');
              } else {
                display = valToLabel[ans] || ans || '';
              }
            } else {
              display = Array.isArray(ans) ? ans.join(' | ') : (ans || '');
            }
            return { question: q.text, answer: display };
          })
        };
        fetch(sheetsUrl, {
          method: 'POST', mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      }

      /* ── question image helper ── */
      function buildQImg(q, pos) {
        if (!q.image || q.imagePosition !== pos) return '';
        return '<img src="' + escAttr(q.image) + '" alt="" class="bz-quiz__q-img bz-quiz__q-img--' + pos + '" loading="lazy">';
      }

      /* ── product reel slot animation (fires on scroll into view) ── */
      function startReel(reelEl, decoys, finalImg, finalName) {
        var valid = (decoys || []).filter(function (x) { return !!x; });
        var imgEl  = reelEl.querySelector('.bz-quiz__reel-img');
        var nameEl = reelEl.querySelector('.bz-quiz__reel-name');
        if (!imgEl || (!valid.length && !finalImg)) return;

        function run() {
          var step  = 0;
          var spins = valid.length ? valid.length * 3 + 2 : 0;

          function delay(s) {
            if (s < spins * 0.45) return 90;
            if (s < spins * 0.70) return 160;
            if (s < spins * 0.88) return 280;
            return 400;
          }

          function tick() {
            if (!valid.length || step >= spins) {
              if (finalImg) imgEl.src = finalImg;
              if (nameEl) nameEl.textContent = finalName || '';
              reelEl.classList.add('bz-quiz__reel--winner');
              return;
            }
            imgEl.src = valid[step % valid.length];
            if (nameEl) nameEl.textContent = '';
            setTimeout(tick, delay(step));
            step++;
          }

          tick();
        }

        if ('IntersectionObserver' in window) {
          var fired = false;
          var obs = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && !fired) {
              fired = true;
              obs.disconnect();
              run();
            }
          }, { threshold: 0.4 });
          obs.observe(reelEl);
        } else {
          setTimeout(run, 500);
        }
      }

      /* ── render result by key (from schema or fallback) ── */
      function renderResultByKey(key) {
        section.classList.add('bz-quiz--result');
        setProgress(questions.length, questions.length);
        var allResults = (quizData && quizData.results) || {};
        var r = allResults[key];
        if (!r) { slidesWrap.innerHTML = '<p style="padding:24px;text-align:center;">Sin resultado configurado para "' + escHtml(key) + '".</p>'; return; }

        var imgHtml = r.image ? '<img src="' + escAttr(r.image) + '" alt="" class="bz-quiz__result-img" loading="lazy">' : '';

        /* Doctor testimonial */
        var drPhoto = quizData.drPhoto || '';
        var drName  = quizData.drName  || '';
        var drRole  = quizData.drRole  || '';
        var drItems = (r.protocol || []).map(function (p) { return '<li>' + fmtProtocol(p) + '</li>'; }).join('');
        var drHtml  = '';
        if (drItems) {
          var drHeaderHtml = '';
          if (drPhoto || drName) {
            drHeaderHtml = '<div class="bz-quiz__dr-header">' +
              (drPhoto ? '<img class="bz-quiz__dr-photo" src="' + escAttr(drPhoto) + '" alt="">' : '') +
              '<div>' +
                (drName ? '<p class="bz-quiz__dr-name">' + escHtml(drName) + '</p>' : '') +
                (drRole ? '<p class="bz-quiz__dr-role">' + escHtml(drRole) + '</p>' : '') +
              '</div>' +
            '</div>';
          }
          drHtml = '<div class="bz-quiz__dr">' +
            drHeaderHtml +
            '<p class="bz-quiz__dr-intro">Mi recomendación para tu caso:</p>' +
            '<ul class="bz-quiz__dr-list">' + drItems + '</ul>' +
          '</div>';
        }

        /* Product reel */
        var reelDecoys   = quizData.reelDecoys   || [];
        var reelFinalImg = quizData.reelFinalImg  || '';
        var reelFinalName= quizData.reelFinalName || '';
        var firstDecoy   = reelDecoys.filter(function (x) { return !!x; })[0] || reelFinalImg;
        var reelHtml = '';
        if (reelDecoys.length || reelFinalImg) {
          reelHtml = '<div class="bz-quiz__reel">' +
            '<p class="bz-quiz__reel-label">Lo que realmente funciona para tu caso</p>' +
            '<div class="bz-quiz__reel-window">' +
              '<img class="bz-quiz__reel-img" src="' + escAttr(firstDecoy) + '" alt="">' +
              '<p class="bz-quiz__reel-name"></p>' +
            '</div>' +
          '</div>';
        }

        /* Before / After */
        var baHtml = '';
        if (r.beforeImg || r.afterImg) {
          baHtml = '<div class="bz-quiz__ba">' +
            (r.beforeImg ? '<div class="bz-quiz__ba-panel"><img src="' + escAttr(r.beforeImg) + '" alt="" loading="lazy"><span class="bz-quiz__ba-tag">Antes</span></div>' : '') +
            (r.afterImg  ? '<div class="bz-quiz__ba-panel"><img src="' + escAttr(r.afterImg)  + '" alt="" loading="lazy"><span class="bz-quiz__ba-tag">Después</span></div>' : '') +
          '</div>';
        }

        slidesWrap.innerHTML =
          '<div class="bz-quiz__result">' +
            imgHtml +
            '<div class="bz-quiz__result-badge">' + renderHtml(r.badge) + '</div>' +
            '<h3 class="bz-quiz__result-type">' + renderHtml(r.headline) + '</h3>' +
            '<p class="bz-quiz__result-desc">' + renderHtml(r.desc) + '</p>' +
            drHtml +
            reelHtml +
            baHtml +
            '<a href="' + escAttr(ctaUrl) + '" class="bz-quiz__result-cta">' + escHtml(ctaText) + '</a>' +
          '</div>';

        if (reelHtml) {
          var reelWindow = slidesWrap.querySelector('.bz-quiz__reel-window');
          if (reelWindow) startReel(reelWindow, reelDecoys, reelFinalImg, reelFinalName);
        }
      }

      /* ── loading animation — plays after last question, before result ── */
      function renderLoading() {
        section.classList.add('bz-quiz--result');
        setProgress(questions.length, questions.length);
        var msgs = [
          'Estudiando tus respuestas…',
          'Identificando tu perfil…',
          'Preparando tu protocolo…'
        ];
        var loadingImg = quizData.loadingImg || '';
        var iconHtml = loadingImg
          ? '<img src="' + loadingImg + '" alt="" class="bz-quiz__loading-img">'
          : '<span class="bz-quiz__loading-icon">🔬</span>';
        slidesWrap.innerHTML =
          '<div class="bz-quiz__loading">' +
            iconHtml +
            '<p class="bz-quiz__loading-title">Analizando tu diagnóstico</p>' +
            '<p class="bz-quiz__loading-msg">' + msgs[0] + '</p>' +
            '<div class="bz-quiz__loading-bar"><div class="bz-quiz__loading-fill"></div></div>' +
          '</div>';
        var fill   = slidesWrap.querySelector('.bz-quiz__loading-fill');
        var msgEl  = slidesWrap.querySelector('.bz-quiz__loading-msg');
        var msgIdx = 0;
        var start  = null;
        var DURATION = 2600;
        function step(ts) {
          if (!start) start = ts;
          var pct = Math.min((ts - start) / DURATION, 1);
          if (fill) fill.style.width = (pct * 100).toFixed(1) + '%';
          var newIdx = pct < 0.4 ? 0 : pct < 0.75 ? 1 : 2;
          if (newIdx !== msgIdx && msgEl) { msgIdx = newIdx; msgEl.textContent = msgs[newIdx]; }
          if (pct < 1) { requestAnimationFrame(step); }
          else { renderResultByKey(calcResult()); }
        }
        requestAnimationFrame(step);
      }

      /* ── intro ── */
      function renderIntro() {
        section.classList.remove('bz-quiz--result');
        setProgress(0, questions.length);
        slidesWrap.innerHTML =
          '<div class="bz-quiz__intro">' +
            '<div class="bz-quiz__intro-badge">✦ Diagnóstico gratuito</div>' +
            '<h3 class="bz-quiz__intro-title">¿Qué tipo de mancha tienes?</h3>' +
            '<p class="bz-quiz__intro-sub">' + questions.length + ' preguntas · 2 minutos · Protocolo personalizado</p>' +
            '<button class="bz-quiz__intro-start">Comenzar diagnóstico →</button>' +
          '</div>';
        slidesWrap.querySelector('.bz-quiz__intro-start').addEventListener('click', function () { renderQ(0); });
      }

      /* ── question ── */
      function renderQ(idx) {
        var q = questions[idx];
        if (!q) return;
        section.classList.remove('bz-quiz--result');
        var isMulti     = !!q.multi;
        var isTextInput = q.qType === 'text';
        setProgress(idx + 1, questions.length);

        var hintHtml  = (q.hint && q.hint.trim()) ? '<p class="bz-quiz__hint">' + renderHtml(q.hint) + '</p>' : '';
        var isLast    = idx === questions.length - 1;
        var nextLabel = isLast ? 'Ver mi diagnóstico →' : 'Siguiente →';
        var backHtml  = idx > 0 ? '<button class="bz-quiz__back">← Atrás</button>' : '';

        var prevAnswer  = answers[q.id];
        var nextDisabled = (!prevAnswer || (Array.isArray(prevAnswer) && prevAnswer.length === 0)) ? ' disabled' : '';

        var inputArea;
        if (isTextInput) {
          var prevVal = (typeof prevAnswer === 'string') ? escAttr(prevAnswer) : '';
          inputArea = '<div class="bz-quiz__opts">' +
            '<input type="number" class="bz-quiz__text-input" min="1" max="120" placeholder="Escribe un número..." value="' + prevVal + '">' +
            '</div>';
        } else {
          var prevSingle = (!isMulti && typeof prevAnswer === 'string') ? prevAnswer : null;
          var prevMulti  = (isMulti  && Array.isArray(prevAnswer))      ? prevAnswer : [];
          var optsHtml = (q.opts || []).map(function (opt) {
            var isSel = isMulti ? (prevMulti.indexOf(opt.val) > -1) : (prevSingle === opt.val);
            var cls = 'bz-quiz__opt' +
              (isMulti   ? ' bz-quiz__opt--multi'   : '') +
              (opt.image ? ' bz-quiz__opt--has-img' : '') +
              (isSel     ? ' bz-quiz__opt--sel'     : '');
            var imgHtml = opt.image ? '<img src="' + escAttr(opt.image) + '" alt="" class="bz-quiz__opt-img" loading="lazy">' : '';
            return '<button class="' + cls + '" data-val="' + escAttr(opt.val) + '">' +
              imgHtml + '<span class="bz-quiz__chk"></span>' +
              '<span class="bz-quiz__opt-label">' + renderHtml(opt.label) + '</span>' +
            '</button>';
          }).join('');
          inputArea = '<div class="bz-quiz__opts">' + optsHtml + '</div>';
        }

        slidesWrap.innerHTML =
          '<div class="bz-quiz__slide">' +
            buildQImg(q, 'above') +
            '<p class="bz-quiz__step">Pregunta ' + (idx + 1) + ' de ' + questions.length + '</p>' +
            '<p class="bz-quiz__q">' + renderHtml(q.text) + '</p>' +
            hintHtml +
            buildQImg(q, 'below') +
            inputArea +
            '<div class="bz-quiz__nav">' +
              backHtml +
              '<button class="bz-quiz__next"' + nextDisabled + '>' + nextLabel + '</button>' +
            '</div>' +
          '</div>';

        var slide   = slidesWrap.querySelector('.bz-quiz__slide');
        var nextBtn = slide.querySelector('.bz-quiz__next');
        var backBtn = slide.querySelector('.bz-quiz__back');

        if (backBtn) {
          backBtn.addEventListener('click', function () {
            if (idx === 0) { renderIntro(); } else { renderQ(idx - 1); }
          });
        }

        if (isTextInput) {
          var textInput = slide.querySelector('.bz-quiz__text-input');
          textInput.addEventListener('input', function () {
            var val = this.value.trim();
            answers[q.id] = val;
            nextBtn.disabled = val === '';
          });
        } else {
          var opts = slide.querySelectorAll('.bz-quiz__opt');
          if (!isMulti) {
            opts.forEach(function (opt) {
              opt.addEventListener('click', function () {
                opts.forEach(function (o) { o.classList.remove('bz-quiz__opt--sel'); });
                this.classList.add('bz-quiz__opt--sel');
                answers[q.id] = this.dataset.val;
                nextBtn.disabled = false;
              });
            });
          } else {
            var selected = Array.isArray(prevAnswer) ? prevAnswer.slice() : [];
            opts.forEach(function (opt) {
              opt.addEventListener('click', function () {
                var val = this.dataset.val;
                var i = selected.indexOf(val);
                if (i > -1) { selected.splice(i, 1); this.classList.remove('bz-quiz__opt--sel'); }
                else         { selected.push(val);    this.classList.add('bz-quiz__opt--sel'); }
                answers[q.id] = selected.slice();
                nextBtn.disabled = selected.length === 0;
              });
            });
          }
        }

        nextBtn.addEventListener('click', function () {
          if (!isLast) { renderQ(idx + 1); }
          else { sendToSheets(); renderLoading(); }
        });
      }

      /* expose handlers so block:select can call them after section:load */
      section._quizGoTo = renderQ;
      section._quizShowResult = renderResultByKey;
      section._quizData = quizData;

      /* if a block was selected before this init ran, jump to it now */
      if (_quizPendingBlock && _quizPendingBlock.sectionId === sectionId) {
        /* keep _quizPendingBlock set — block may still be selected if section reloads again */
        if (!_quizJumpToBlock(section, _quizPendingBlock.blockId)) renderIntro();
      } else {
        renderIntro();
      }
    });
  }

  /* Block selected in theme editor: jump to that question/result in preview */
  document.addEventListener('shopify:block:select', function (e) {
    var sectionId = e.detail.sectionId;
    var blockId   = e.detail.blockId;
    var sectionEl = document.getElementById('bz-quiz-' + sectionId);
    if (!sectionEl) return;

    /* Design mode: all blocks visible as cards — just scroll to the selected card */
    if (sectionEl.dataset.designMode) {
      var card = e.target;
      if (card && card.scrollIntoView) {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    _quizPendingBlock = { sectionId: sectionId, blockId: blockId };

    /* Primary path: event.target IS the bmap span (has {{ block.shopify_attributes }}) */
    var tgt = e.target;
    if (tgt && tgt.dataset && tgt.dataset.bid) {
      if (tgt.dataset.btype === 'q' && sectionEl._quizGoTo) {
        sectionEl._quizGoTo(parseInt(tgt.dataset.bidx, 10));
        return;
      }
      if (tgt.dataset.btype === 'r' && sectionEl._quizShowResult) {
        sectionEl._quizShowResult(tgt.dataset.bkey);
        return;
      }
    }
    /* Fallback: search bmap spans by blockId string */
    if (sectionEl._quizGoTo) _quizJumpToBlock(sectionEl, blockId);
  });

  /* On deselect restore intro */
  document.addEventListener('shopify:block:deselect', function (e) {
    _quizPendingBlock = null;
    var sectionEl = document.getElementById('bz-quiz-' + e.detail.sectionId);
    if (sectionEl && sectionEl._quizGoTo) {
      var dataEl = document.getElementById('bz-quiz-data-' + e.detail.sectionId);
      if (dataEl) {
        try {
          var qd = JSON.parse(dataEl.textContent);
          var slidesWrap = sectionEl.querySelector('.bz-quiz__slides');
          var progressFill = sectionEl.querySelector('.bz-quiz__progress-fill');
          if (slidesWrap && progressFill) {
            var total = (qd.questions || []).length;
            progressFill.style.width = '0%';
            slidesWrap.innerHTML =
              '<div class="bz-quiz__intro">' +
                '<div class="bz-quiz__intro-badge">✦ Diagnóstico gratuito</div>' +
                '<h3 class="bz-quiz__intro-title">¿Qué tipo de mancha tienes?</h3>' +
                '<p class="bz-quiz__intro-sub">' + total + ' preguntas · 2 minutos · Protocolo personalizado</p>' +
                '<button class="bz-quiz__intro-start">Comenzar diagnóstico →</button>' +
              '</div>';
            slidesWrap.querySelector('.bz-quiz__intro-start').addEventListener('click', function () {
              if (sectionEl._quizGoTo) sectionEl._quizGoTo(0);
            });
          }
        } catch (err) {}
      }
    }
  });

  /* Recent-sales notification — rotating social-proof toast, bottom-left */
  function initRecentSales() {
    document.querySelectorAll('.bz-rp').forEach(function (root) {
      if (root.dataset.wired) return;
      root.dataset.wired = 'true';

      if (root.dataset.enabled !== 'true') return;

      var dataEl = document.getElementById(root.id.replace('bz-rp-', 'bz-rp-data-'));
      if (!dataEl) return;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var names = (data && data.names) || [];
      var cities = (data && data.cities) || [];
      if (!names.length || !cities.length) return;

      var product = root.dataset.product || 'nuestro tratamiento';
      var firstDelay = (parseFloat(root.dataset.firstDelay) || 8) * 1000;
      var minInterval = (parseFloat(root.dataset.intervalMin) || 25) * 1000;
      var maxInterval = (parseFloat(root.dataset.intervalMax) || 45) * 1000;
      var displayDuration = (parseFloat(root.dataset.displayDuration) || 6) * 1000;

      var timeTexts = [
        'hace unos segundos', 'hace 1 minuto', 'hace 2 minutos',
        'hace 3 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos'
      ];

      function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
      function escHtml(s) {
        return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }

      var counter = 0;

      function showToast() {
        var name = pick(names);
        var city = pick(cities);
        var time = pick(timeTexts);
        var initial = name.trim().charAt(0).toUpperCase() || '•';
        var id = 'bz-rp-card-' + (++counter);

        var card = document.createElement('div');
        card.className = 'bz-rp__card';
        card.id = id;
        card.innerHTML =
          '<span class="bz-rp__avatar">' + escHtml(initial) + '</span>' +
          '<button type="button" class="bz-rp__close" aria-label="Cerrar">&#215;</button>' +
          '<div class="bz-rp__body">' +
            '<p class="bz-rp__name">' + escHtml(name) + '</p>' +
            '<p class="bz-rp__action">acaba de comprar <strong>' + escHtml(product) + '</strong> en ' + escHtml(city) + '</p>' +
            '<p class="bz-rp__time">' + escHtml(time) + '</p>' +
          '</div>';

        root.appendChild(card);
        requestAnimationFrame(function () { card.classList.add('bz-rp__card--show'); });

        function dismiss() {
          card.classList.remove('bz-rp__card--show');
          card.classList.add('bz-rp__card--hide');
          setTimeout(function () { if (card.parentElement) card.remove(); }, 400);
        }

        card.querySelector('.bz-rp__close').addEventListener('click', dismiss);
        setTimeout(dismiss, displayDuration);

        while (root.children.length > 2) {
          root.removeChild(root.firstElementChild);
        }
      }

      function loop() {
        showToast();
        var next = minInterval + Math.random() * (maxInterval - minInterval);
        setTimeout(loop, next);
      }

      setTimeout(loop, firstDelay);
    });
  }

  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
